var React = require('react');

function Dropdown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.64059 9.47444L0.808594 1.64244V0.523438H1.92759L8.64059 7.23644L15.3536 0.523438H16.4726V1.64244L8.64059 9.47444Z","fill":"#DEEDED","stroke":"#DEEDED","strokeWidth":"0.5","strokeLinejoin":"round"}));
}

Dropdown.defaultProps = {"width":"17","height":"10","viewBox":"0 0 17 10","fill":"none"};

module.exports = Dropdown;

Dropdown.default = Dropdown;
